<style></style>
<template>
    <transition name="fade">
        <div class="error-message" v-show="hasErrors">
            <div v-for="(msg, idx) in messages" :key="idx"><strong>{{msg}}</strong></div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: {
            messages: {
                required: true
            }
        },
        computed: {
            hasErrors: function () {
                if (typeof this.messages == 'undefined') {
                    return false
                }
                return true
            }
        }
    }
</script>